import { IOptionProps } from "../ZSelect/interface";
import { InputNumberProps } from "antd/es/input-number";
import { ReactText } from "react";

export interface IInputNumberProps extends InputNumberProps<number> {
	readonly defaultString?: ReactText;
	readonly addOnAfter?: string;
	readonly zref?:
		| React.RefObject<HTMLInputElement>
		| ((instance: HTMLInputElement | null) => void)
		| null;
	readonly selectAddOn?: boolean;
	readonly options?: IOptionProps[];
	readonly selectValue?: string;
	readonly onSelectChange?: (value: string) => void;
}

export enum EInputNumberWidths {
	sm = "sm",
	md = "md",
	lg = "lg",
	xl = "xl",
	full = "full"
}
